import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14 max-w-3xl"
        >
          <div className="text-[11px] uppercase tracking-[0.22em] text-amber-600 font-bold flex items-center gap-2">
            <span className="w-8 h-px bg-amber-500" />
            Client Voices
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-navy-900 tracking-tighter leading-[1]">
            What our partners
            <br />
            <span className="text-amber-500">say about us.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="lift-card relative bg-white border border-slate-200 rounded-2xl p-8"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-8 h-8 text-amber-500 mb-5" />
              <p className="text-navy-900 font-display text-lg leading-snug tracking-tight">
                {t.quote}
              </p>
              <div className="mt-7 pt-5 border-t border-slate-100">
                <div className="text-sm font-bold text-navy-900">{t.author}</div>
                <div className="text-xs text-slate-500 mt-1">{t.company}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
